import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ShiJumpingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shi-jumping",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 17.5l-5 -4.5v-6l5 4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 17.5l5 -4.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.103 21.58l6.762 -14.502a2 2 0 0 0 -.968 -2.657"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.897 21.58l-6.762 -14.503a2 2 0 0 1 .968 -2.657"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 11l5 -4"
    }, null), _createTextVNode(" ")]);
  }
};